<i18n locale="en">
{
  "labels": {
    "more": "More"
  }
}
</i18n>

<template>
  <div class="navbar-menu-link-preview align-center flex-row gap-6">
    <PreviewNavLink
      v-for="link of navLinkDisplay"
      :key="navItemKey(link)"
      :label="
        ['page', 'external'].includes(link.type)
          ? link?.params?.label
          : link?.params?.title
      "
    />
    <NavbarDropdownPreview
      v-if="navLinkDisplay.length !== navLinks.length"
      :label="t('labels.more')"
    />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

import PreviewNavLink from '@/lib/builder/public/preview/PreviewNavLink.vue'

import { navItemKey } from '../common/navItemKey'

import NavbarDropdownPreview from './NavbarDropdownPreview'

export default {
  name: 'NavbarMenuLinkPreview',
  components: {
    NavbarDropdownPreview,
    PreviewNavLink,
  },
  props: {
    /**
     * Active page to show
     */
    activePage: { type: String, default: undefined },
    navLinks: { type: Array, default: () => [] },
  },
  setup() {
    const { t } = useI18n()

    return { t }
  },
  computed: {
    navLinkDisplay() {
      const { navLinks } = this

      return navLinks.slice(0, 3)
    },
  },
  methods: {
    navItemKey,
  },
}
</script>
